module.exports = __webpack_public_path__ + "img/2.6a838d60.png";